<template>
    <v-card
    flat
    color="#F9F9F9"
     max-width="300"
    class="mx-auto mt-10"
    >
    <img width='300px' :src='src' />
  <p class='text-center title'>{{message}}</p>
    </v-card>
</template>

<script>
export default {
    props : {
        message : String,
        src : String,
    }
}
</script>